import { ClipboardCheck, MessageSquareText, CalendarPlus, Timer, FlaskConical } from "lucide-react";

const INDICATORS = [
  { icon: ClipboardCheck, label: "Menos seguimiento manual" },
  { icon: MessageSquareText, label: "Más respuestas claras" },
  { icon: CalendarPlus, label: "Más huecos ofrecidos a pacientes disponibles" },
  { icon: Timer, label: "Menos tiempo entre cancelación y reocupación" },
];

export default function DemoCase() {
  return (
    <section id="caso" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-dashed border-navy/25 bg-platinum/60 p-8 sm:p-12">
          <span
            data-testid="demo-case-badge"
            className="inline-flex items-center gap-2 rounded-full border border-navy/20 bg-white px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-navy"
          >
            <FlaskConical className="h-3.5 w-3.5 text-navy-light" strokeWidth={2} />
            Caso demostrativo
          </span>

          <h2
            data-testid="demo-case-title"
            className="mt-6 font-heading text-2xl font-extrabold tracking-tight text-navy sm:text-3xl"
          >
            Cómo se comporta el sistema en una clínica con varias agendas
          </h2>

          <p className="mt-5 max-w-3xl text-base leading-relaxed text-steel sm:text-lg">
            Una clínica con varias agendas recibe decenas de cancelaciones y
            confirmaciones ambiguas cada mes. Tras activar confirmaciones dinámicas,
            detección de riesgo y lista de espera inteligente, puede priorizar las citas
            de mayor riesgo y ofrecer rápidamente los huecos disponibles.
          </p>

          <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {INDICATORS.map((item) => (
              <div
                key={item.label}
                data-testid={`demo-indicator-${item.label.toLowerCase().replace(/\s+/g, "-").slice(0, 30)}`}
                className="flex flex-col gap-3 rounded-xl border border-[#E8EDF5] bg-white p-5 shadow-sm"
              >
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#E7F4EC]">
                  <item.icon className="h-5 w-5 text-recover" strokeWidth={1.8} />
                </div>
                <p className="text-sm font-semibold leading-snug text-navy">{item.label}</p>
              </div>
            ))}
          </div>

          <p className="mt-8 text-xs leading-relaxed text-steel">
            Este caso es un ejemplo ilustrativo con fines demostrativos. No describe
            resultados reales ni está atribuido a ninguna clínica concreta.
          </p>
        </div>
      </div>
    </section>
  );
}
